export class PwaConfig {
  brand?: string;
  isInstalled?: boolean;
}
